// extracted by mini-css-extract-plugin
module.exports = {"comp":"WhatInBox_comp__heHBY"};